import { render, staticRenderFns } from "./McFormDualInputs.vue?vue&type=template&id=4eb13206"
import script from "./McFormDualInputs.vue?vue&type=script&lang=js"
export * from "./McFormDualInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports